import { find } from 'lodash-es';

import { countryPrefixes } from '@aw/shared/constants';

export const coerceCountryCallingCode = (value: string) =>
  value.startsWith('+') ? value : `+${value}`;

export const isCountryCallingCode = (countryCallingCode: string): boolean =>
  !!find(countryPrefixes, {
    prefix: coerceCountryCallingCode(countryCallingCode),
  });
